var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGirl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 203.736 203.736",
    style: {
      enableBackground: "new 0 0 203.736 203.736"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#543C2A"
    },
    d: "M101.867,66.139v131.395h60.26c0,0,11.449-59.365,11.168-95.113 C173.014,66.673,101.867,66.139,101.867,66.139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#543C2A"
    },
    d: "M101.867,66.139v131.395H41.609c0,0-11.449-59.365-11.168-95.113 C30.721,66.673,101.867,66.139,101.867,66.139z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 87.17,
    y: 153.47,
    style: {
      fill: "#FDCC9B"
    },
    width: 29.395,
    height: 32.923
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCBC85"
    },
    d: "M87.17,157.348c0,0,12.365,7.874,29.395,6.051v-9.929H87.17V157.348z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FCBC85"
    },
    cx: 44.784,
    cy: 102.42,
    rx: 14.343,
    ry: 16.364
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FCBC85"
    },
    cx: 158.952,
    cy: 102.42,
    rx: 14.343,
    ry: 16.364
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDCC9B"
    },
    d: "M158.894,71.165c0-24.104-17.637-41.741-57.026-41.741c-39.389,0-57.025,17.637-57.025,41.741 c0,24.104-4.115,87.597,57.025,87.597C163.009,158.762,158.894,95.269,158.894,71.165z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#3B2519"
    },
    cx: 74.092,
    cy: 98.502,
    rx: 6.173,
    ry: 6.761
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 71.401,
    cy: 95.517,
    r: 1.846
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#684B37"
    },
    d: "M64.217,83.925c2.919,1.117,7.605-3.798,18.335,0.478c1.956,0.78,3.123-6.668-8.378-6.668 C64.217,77.735,62.453,83.25,64.217,83.925z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#3B2519"
    },
    cx: 130.406,
    cy: 98.502,
    rx: 6.173,
    ry: 6.761
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 127.715,
    cy: 95.517,
    r: 1.846
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#684B37"
    },
    d: "M139.519,83.925c-2.919,1.117-7.606-3.798-18.335,0.478c-1.956,0.78-3.123-6.668,8.377-6.668 C139.519,77.735,141.282,83.25,139.519,83.925z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCBC85"
    },
    d: "M101.867,122.283c-6.099,0-9.773-4.557-9.773-2.352c0,2.204,1.764,6.394,9.773,6.394 c8.011,0,9.774-4.189,9.774-6.394C111.642,117.726,107.967,122.283,101.867,122.283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCBC85"
    },
    d: "M101.867,142.553c-2.109,0-3.38-1.575-3.38-0.814c0,0.763,0.61,2.212,3.38,2.212 c2.771,0,3.381-1.449,3.381-2.212C105.248,140.978,103.978,142.553,101.867,142.553z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7945E"
    },
    d: "M101.867,136.936c-9.668,0-15.492-3.937-15.492-2.939s2.795,4.924,15.492,4.924 s15.493-3.927,15.493-4.924S111.535,136.936,101.867,136.936z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F9AA8D"
    },
    cx: 66.154,
    cy: 120.108,
    r: 8.377
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F9AA8D"
    },
    cx: 138.611,
    cy: 120.108,
    r: 8.377
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5A860"
    },
    d: "M101.867,166.699v37.037H37.495C37.495,188.745,68.064,166.699,101.867,166.699z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5A860"
    },
    d: "M101.867,166.699v37.037h64.373C166.24,188.745,135.672,166.699,101.867,166.699z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F18B45"
    },
    d: "M89.6,167.651c-0.189,0.027-0.379,0.065-0.569,0.094c-3.963,0.634-7.829,1.529-11.543,2.653 l24.38,33.338v-18.518L90.87,167.501C90.449,167.56,90.02,167.587,89.6,167.651z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F18B45"
    },
    d: "M114.135,167.651c0.19,0.027,0.38,0.065,0.57,0.094c3.963,0.634,7.829,1.529,11.543,2.653 l-24.381,33.338v-18.518l10.998-17.716C113.286,167.56,113.716,167.587,114.135,167.651z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#684B37"
    },
    d: "M101.867,0C35.436,0,27.651,46.991,30.441,102.42c2.79,55.43,49.824,82.797,49.824,82.797 S27.56,109.79,71.401,43.651c0,0-8.232,14.157-7.786,26.015c0,0,10.328-3.527,38.253-3.527c27.926,0,38.253,3.527,38.253,3.527 c0.447-11.858-7.785-26.015-7.785-26.015c43.841,66.138-8.865,141.566-8.865,141.566s47.035-27.367,49.825-82.797 C176.085,46.991,168.3,0,101.867,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDCC9B"
    },
    d: "M87.17,167.981l14.697,24.408l14.697-24.409C116.565,167.98,101.317,162.428,87.17,167.981z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirl);
export default __webpack_public_path__ + "static/media/girl.9bac2236047117b010b93a341dfa6cb3.svg";
export { ForwardRef as ReactComponent };